module.exports = __webpack_public_path__ + "static/screen4-0c1355f8aed4a14d2f76316b03977f43.png";